import styled from 'styled-components';
import { H3 } from 'components/Typography';
import DefaultIndicator from 'components/Indicator';
import DefaultDatesSelector from 'components/Form/WeekRangePicker';
import DefaultPieChart from 'components/Charts/PieChart';
import DefaultAreaChart from 'components/Charts/AreaChart';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  width: 100%;
  height: auto;
  padding: 0;
  margin-bottom: 8rem;
`;

// TODO: TFR-44 move to typography group
export const SectionTitle = styled(H3)`
  margin-bottom: 1rem;
`;

// TODO: TFR-45:Date make unique name or do not export
export const DateCaption = styled(H3)`
  margin-right: 1.5rem;
`;

// TODO: TFR-45:Header make unique name or do not export
export const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
`;

// TODO: TFR-44 move to container group
export const Indicators = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
`;

// TODO: TFR-44 move to container group
export const TwoColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
`;

// TODO: TFR-44 move to container group
export const TwoRows = styled.div`
  display: grid;
  grid-template-rows: 17rem 17rem;
  gap: 4rem;
`;

// TODO: TFR-44 move to container group
export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

// TODO: TFR-44 move to container group
export const Section = styled.div``;

// TODO: TFR-44 move to container group
export const RevenueSection = styled.div`
  height: 39.8rem;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Indicator = styled(DefaultIndicator)``;

// TODO: TFR-45:Date make unique name or do not export
export const DatesSelector = styled(DefaultDatesSelector)``;

export const ChartWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  border-radius: 1rem;
  padding: 2.125rem 2rem;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const PieChart = styled(DefaultPieChart)``;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const AreaChart = styled(DefaultAreaChart)``;
